import BackgroundComponent from "../../components/Layout/BackgroundProfile/BackgroundProfile";
import ProfileViewModeBg from "../../assets/images&icons/profileViewMode.jpeg";
import TabManager from "../../components/Layout/TabManager/TabManager";
import { useEffect, useMemo, useState } from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import {
  countUniqueMembersAuthors,
  countFirmsWithArticles,
} from "../../Services/Content";
import { IContent, IContentFilters } from "../../interfaces";
import {
  contentStatusEnum,
  isApprovedEnum,
  submissionTypeEnum,
} from "../../Enums/ContentEnums";
import { UseFirmList } from "../../hooks/Catalogs/useFirm";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import { useDispatch, useSelector } from "react-redux";
import { Appstore, contentsSlice, pageState } from "../../redux";
import { useLocation } from "react-router-dom";
import {
  formatDateToString,
  formatTimeSpanToString,
} from "../../utils/functions";
import useDataLoader2 from "../../hooks/useDataLoader2";
import { defaultPageSize } from "../../utils/const";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import Filters, {
  IFilterData,
} from "../../components/Catalogs/Filters/Filters";
import { UsePracticeIndustryList } from "../../hooks/Catalogs/usePracticeIndustry";
import { UseRegionList } from "../../hooks/Catalogs/useRegionListOptions";
import { Option } from "../../components/Atomos/DropDown/DDMultiple";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";
interface contentProps {
  breadcrumb: { prevPage: string; currentPage: string };
  persistentFilter?: any;
  firmId?: string;
}

const MemberReportsContent: React.FC<contentProps> = ({
  breadcrumb,
  persistentFilter,
  firmId,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [KPI, setKPI] = useState({
    uniqueMemberAuthors: undefined,
    firmsWithArticles: undefined,
  });
  const [disabledFirmFilter, setDisabledFirmFilter] = useState<boolean>(false);
  const { firmData } = UseFirmList();
  const [firmOptions, setFirmOptions] = useState<Option[]>([]);
  const { practiceIndustryData } = UsePracticeIndustryList();
  const { regionData } = UseRegionList();

  const dispatch = useDispatch();

  const [processedData, setProcessedData] = useState<any[]>([]);
  const { pathname } = useLocation();
  const endpoint = "/content";

  const {
    data,
    totalCount,
    fetchData,
    setFilter,
    sort,
    setSort,
    pagination,
    setPagination,
    inputFilters,
    setInputFilters,
    filter,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    persistentFilter: {
      ...persistentFilter,
    },
  });

  useEffect(() => {
    // setTimeout(() => fetchData(false, true), 500);
    fetchData(false, true);
  }, [pathname]);

  useEffect(() => {
    setProcessedData(processData(data));
  }, [data]);

  useEffect(() => {
    setFirmOptions(firmData.map((f: any) => ({ id: f.id, name: f.name })));
  }, [firmData]);

  useEffect(() => {
    setDisabledFirmFilter(!!firmId);
    setInputFilters((prev: any) => ({ ...prev, Firm: [] }));

    let filtersAux = firmId ? { memberFirms: { value: [firmId] } } : {};

    if (!KPI.uniqueMemberAuthors || !KPI.firmsWithArticles) {
      updateKPI(filtersAux);
    }
    dispatch(contentsSlice.actions.InitializeContent());
  }, [firmId]);

  useEffect(() => {
    if (disabledFirmFilter && firmOptions) {
      const currentFirm = firmOptions.find((f: Option) => f.id === firmId);
      setInputFilters((prev: IContentFilters) => ({
        ...prev,
        Firm: [currentFirm],
      }));
    }
  }, [disabledFirmFilter]);

  const updateKPI = async (filtersAux: any) => {
    try {
      const [uniqueMembersResp, firmsResp] = await Promise.all([
        countUniqueMembersAuthors(filtersAux),
        countFirmsWithArticles(filtersAux),
      ]);

      setKPI((prevState) => ({
        ...prevState,
        uniqueMemberAuthors: uniqueMembersResp.uniqueMemberAuthors,
        firmsWithArticles: firmsResp.totalFirmWithArticles,
      }));
    } catch (error) {
      console.error("Error updating KPI:", error);
    }
  };

  useEffect(() => {
    setPagination({ ...pagination, pageIndex: 0 });
    fetchData(false, true);
  }, [selectedTab]);

  const processData = (data: IContent[]) => {
    return data.map((d: IContent) => ({
      ...d,
      type: submissionTypeEnum[d.submissionType],
      isApproved: d.isApproved,
      writtenDate: d.writtenDate && formatDateToString(new Date(d.writtenDate)),
      publishedDate:
        d.publishedDate === "pending"
          ? contentStatusEnum.pending
          : d.publishedDate && formatDateToString(new Date(d.publishedDate)),
      reviewedDate:
        d.reviewedDate === "pending"
          ? contentStatusEnum.pending
          : d.reviewedDate && formatDateToString(new Date(d.reviewedDate)),
      firms: d.firmNames,
      practiceIndustries: d.practiceIndustryNames,
      jurisdictions: d.jurisdictionNames,
      regions: d.regionNames,
      views: d.views ?? 0,
    }));
  };

  const storedPageState = useSelector((state: Appstore) => state.pageState);
  useEffect(() => {
    const storedPage = storedPageState[pathname] || {};
    const storedSelectedTab = storedPage.selectedTab;
    setSelectedTab(storedSelectedTab || 0);
  }, []);

  useEffect(
    function saveSelectedTabState() {
      dispatch(
        pageState.actions.setPageState({
          pathname,
          pageState: { selectedTab: selectedTab },
        }),
      );
    },
    [pathname, selectedTab],
  );

  const columnsDef = useMemo(
    () => [
      {
        id: "count",
        header: "#",
        enableSorting: false,
        cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
          <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
        ),
      },
      { id: "shortId", header: "Short ID" },
      { id: "title", header: "Title" },
      {
        id: "firms",
        header: "Firms",
        cell: ({ value }: { rowIndex: number; row: any; value: any }) => value,
      },
      {
        id: "isApproved",
        header: "Status",
        cell: ({ value }: { rowIndex: number; row: any; value: any }) => {
          let text = "";
          let color = "";

          switch (value) {
            case "yes":
              text = "Approved";
              color = "#2AA042";
              break;
            case "no":
              text = "Rejected";
              color = "#FF6109";
              break;
            case "pending":
              text = "Pending";
              color = "#C6A80D";
              break;
            default:
              text = value;
              break;
          }

          return <span style={{ color }}>{text}</span>;
        },
      },
      { id: "reviewedBy", header: "Reviewed By" },
      {
        id: "writtenDate",
        header: "Written Date",
        cell: ({ value }: { rowIndex: number; row: any; value: any }) =>
          value === "pending" ? isApprovedEnum["pending"] : value,
      },
      {
        id: "publishedDate",
        header: "Published Date",
        cell: ({ value }: { rowIndex: number; row: any; value: any }) =>
          value === "pending" ? isApprovedEnum["pending"] : value,
      },
      {
        id: "practiceIndustries",
        header: "Practice Industries",
        cell: ({ value }: { rowIndex: number; row: any; value: any }) => value,
      },
      { id: "views", header: "Views" },
      { id: "jurisdictions", header: "Jurisdictions" },
      {
        id: "regions",
        header: "Regions",
        cell: ({ row, value }: { rowIndex: number; row: any; value: any }) => {
          const isGlobal = row.jurisdictions;
          return isGlobal == "Global" ? "Global" : value;
        },
      },
      {
        id: "_ts",
        header: "Created Date",
        cell: ({ value }: { rowIndex: number; row: any; value: any }) => {
          return value ? formatTimeSpanToString(value) : "";
        },
      },
      {
        id: "manage",
        header: "Manage",
        enableSorting: false,
        cell: ({
          row,
          rowIndex,
        }: {
          rowIndex: number;
          row: any;
          value: any;
        }) => (
          <PersistentLink
            className="edit"
            to={`${
              disabledFirmFilter ? "/ManageFirm/Content/" : ""
            }Manage/${row.id}`}
            state={data[rowIndex]}
            persistingData={{
              pagination,
              sort,
              filter,
              inputFilters,
            }}
          >
            Manage
            <div className="editsvg">
              <ShapeEdit />
            </div>
          </PersistentLink>
        ),
      },
    ],
    [
      pagination.pageIndex,
      pagination.pageSize,
      sort,
      filter,
      inputFilters,
      data,
      disabledFirmFilter,
    ],
  );

  const statusOptions = Object.entries(isApprovedEnum).map(([id, name]) => ({
    id,
    name,
  }));

  const filtersData: IFilterData[] = useMemo(
    () => [
      {
        name: "Title",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Firm",
        fieldName: "memberFirms",
        objectData: firmOptions || [],
        disabled: disabledFirmFilter,
      },
      {
        name: "Status",
        fieldName: "isApproved",
        objectData: statusOptions,
        comparison: "EQUAL",
      },
      {
        name: "Practice Industry",
        fieldName: "practiceIndustries",
        objectData:
          practiceIndustryData?.map((f: any) => ({ id: f.id, name: f.name })) ||
          [],
      },
      {
        name: "Region",
        fieldName: "regions",
        objectData:
          regionData?.map((f: any) => ({ id: f.id, name: f.name })) || [],
      },
      {
        name: "Written Date",
        fieldName: "writtenDate",
        type: "date",
        comparison: "BETWEEN",
      },
      {
        name: "Published Date",
        fieldName: "publishedDate",
        type: "date",
        comparison: "BETWEEN",
      },
    ],
    [firmOptions, practiceIndustryData, regionData, disabledFirmFilter],
  );

  return (
    <>
      <BackgroundComponent image={ProfileViewModeBg} />
      <div className="bg-gray-100 min-h-screen text-left px-4 py-7 items-start flex flex-col gap-[1.5rem] md:py-8 md:px-6 lg:py-10 lg:px-10 lg:gap-[2.5rem]">
        <div className="flex flex-col items-start gap-5 self-stretch">
          <div className="w-full relative z-10 flex gap-5 md:gap-6 lg:gap-7 self-stretch !p-0 flex-col ">
            <div className="flex p-0 flex-col justify-center gap-5 self-stretch md:flex-row lg:justify-between lg:gap-6">
              <h2 className="text-left w-full lg:w-max text-white font-decimal text-[2.25rem] font-medium leading-[2.75rem] md:text-[2.75rem] md:leading-[3.25rem] lg:text-[3.25rem] lg:leading-[4.5rem]">
                Content
              </h2>
            </div>
            <hr className="flex h-0 justify-center items-center self-stretch relative z-10" />
            <div className="flex w-full"></div>
            <div className="flex w-full text-center">
              <div className="w-full md:w-[28rem] flex gap-5">
                <div className="flex flex-col">
                  <div className="bg-Default text-xs lg:text-base text-white py-[3px] px-4">
                    # UNIQUE MEMBER AUTHORS
                  </div>
                  <div className="bg-white text-[26px] md:text-[28px] lg:text-[32px] font-medium p-4">
                    {KPI.uniqueMemberAuthors ?? "-"}
                  </div>
                </div>
                <div className="flex flex-col">
                  <div className="bg-Default text-xs lg:text-base text-white py-[3px] px-4">
                    TOTAL # OF FIRMS WITH CONTENT
                  </div>
                  <div className="bg-white text-[26px] md:text-[28px] lg:text-[32px] font-medium p-4">
                    {KPI.firmsWithArticles ?? "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <CatalogTableC
                catalogName={"CONTENT"}
                route={"Content"}
                catalogShortName={"Member Report"}
                totalCount={totalCount}
                linkToAdd={
                  disabledFirmFilter
                    ? "/ManageFirm/Content/Create"
                    : "/content/create"
                }
                state={{ contentType: "memberReports" }}
              >
                <Filters
                  filtersData={filtersData}
                  filterValues={inputFilters}
                  setFilterValues={setInputFilters}
                  Search={() => fetchData()}
                  clearSelections={() => fetchData(true)}
                  setValueForQuery={setFilter}
                  persistentFilter={["Firm"]}
                />
                <PaginatedTable
                  data={processedData || []}
                  columnsDef={columnsDef}
                  sorting={sort}
                  onSortingChange={setSort}
                  totalCount={totalCount || 0}
                  pagination={pagination}
                  onPaginationChange={setPagination}
                  endpoint={endpoint}
                  onExportAll={() =>
                    exportAllDataLoader2<any>({
                      endpoint,
                      filter,
                      sort,
                      pageSize: 1000,
                    })
                  }
                />
              </CatalogTableC>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberReportsContent;
